import { AxiosInstance } from 'axios'
import { useAdminStore } from '@getmayday/vue-modules'
import sanitizeHTML from '@commons/utils/sanitizeHTML'

type HelpdeskStore = {
  adminClient: AxiosInstance | null
  client: any | null
  userId: string | null
  userEmail: string | null
  authLoading: boolean
  initClient: () => Promise<any>
  login: () => Promise<any>
  injectAnswer: (answer: string) => Promise<any>
  dispatchAction: (action: any) => Promise<any>
}

export const useIadvizeStore = (store: HelpdeskStore, adminClient: AxiosInstance) => {
  // state
  store.adminClient = adminClient

  // actions
  store.initClient = async () => {
    if (window.location.hostname === 'localhost') return
    try {
      // @ts-ignore
      const client = await window.idzCpa.init()
      if (client) {
        store.client = client
        console.log('iAdvize initialized')
        return client
      } else throw new Error('Error while initializing iAdvize')
    } catch (e) {
      console.error('Error while initializing iAdvize', e)
      return null
    }
  }

  store.login = async () => {
    if (!store.adminClient) return
    store.authLoading = true
    const adminStore = useAdminStore()
    const projectId = store.client?.context.projectId
    try {
      const { data } = await store.adminClient.post(`/login/iadvize/${projectId}`, null, {
        headers: {
          'x-iadvize-token': await store.client?.getJWT()
        }
      })
      const { accessToken, refreshToken, accessExpirationDate } = data
      const configStore = useConfigStore()
      await adminStore.initSessionFromToken({
        accessToken,
        refreshToken,
        accessExpirationDate
      })
      await configStore.initAppFromLogin()
      store.authLoading = false
      return data
    } catch (e) {
      console.error('Error while logging in iAdvize', e)
      store.authLoading = false
      return null
    }
  }

  store.injectAnswer = async (answer: string) => {
    store.client?.insertTextInComposeBox(await sanitizeHTML(answer))
  }

  return store
}
